import type { WorkshopDate } from '~/types/supabase'
import { isUpcomingWorkshop } from './isUpcomingWorkshop'

// Every workshop surface must advertise and book the same occurrence.
export const selectWorkshopDate = (
  dates: readonly WorkshopDate[] | null | undefined,
  today = new Date().toISOString().slice(0, 10)
): WorkshopDate | null => {
  const byDate = (a: WorkshopDate, b: WorkshopDate) =>
    a.start_date.localeCompare(b.start_date) || a.id.localeCompare(b.id)
  const upcoming = (dates || []).filter((date) => isUpcomingWorkshop(date, today)).sort(byDate)
  if (upcoming.length) return upcoming[0]
  return (dates || []).filter((date) => date.start_date.slice(0, 10) < today).sort(byDate).at(-1) || null
}
